import { Button } from 'app/components/ui/Button'
import React, { useState } from 'react'
import styled from 'styled-components'

import { MswDevToolsPanel } from './MswDevToolsPanel'

const MswDevTools = (): JSX.Element => {
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  return (
    <>
      {isPanelOpen ? (
        <MswDevToolsPanel onPanelClose={() => setIsPanelOpen(false)} />
      ) : (
        <MswDevToolsButton onClick={() => setIsPanelOpen(true)} shadow>
          Mock DevTools
        </MswDevToolsButton>
      )}
    </>
  )
}

const MswDevToolsButton = styled(Button)`
  position: fixed;
  z-index: 99999;
  display: inline-flex;
  margin: 0.5rem;
  bottom: 0px;
  right: 0px;

  :hover {
    opacity: 1;
  }
`

export default MswDevTools
